import React from 'react';
import Loader from '../animation/Loader.style';
import LoadingText from '../animation/LoadingText';
import { Box } from '../layout';
import { Container, BoxRow, BoxColumn } from './AuctionBox.style';

const AuctionBoxPlaceholder: React.FC = () => (
  <Container>
    <Box p={15} display="flex" flexDirection="column" gap={15}>
      <Loader display="block" w="36px" h="36px" center />
      <LoadingText textLength={8} />
      <LoadingText textLength={12} />
    </Box>

    <BoxRow>
      <BoxColumn>
        <Loader display="block" w="36px" h="36px" center mb={10} />
        <LoadingText textLength={8} />
      </BoxColumn>
      <BoxColumn>
        <Loader display="block" w="36px" h="36px" center mb={10} />
        <LoadingText textLength={8} />
      </BoxColumn>
    </BoxRow>

    <Box p={15} display="flex" flexDirection="column" gap={15}>
      <LoadingText textLength={8} />
    </Box>
  </Container>
);

export default AuctionBoxPlaceholder;
